import React from "react";
import { 
    Dialog,
    DialogContent,
    DialogContentText,
    Typography,
    IconButton,
} from "@material-ui/core/";
import CloseIcon from '@material-ui/icons/Close';

export default function ModalEndereco(props) {
    return (
        <div>
            <Dialog
                open={props.state.openEndereco}
                onClose={props.handleDialogEndereco}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <Typography variant="h5">
                        {"Endereços"}
                        {props.state.openEndereco ? (
                            <IconButton aria-label="close" style={{ float: "right"}} onClick={props.handleDialogEndereco}>
                                <CloseIcon />
                            </IconButton>
                        ) : null}
                    </Typography>

                    <Typography variant="subtitle2">
                        {"Estok Comércio e Representações Ltda."}
                    </Typography>
                    <br/>
                    
                    <Typography variant="subtitle2">
                        {"Escritório Central:"}
                    </Typography>
                    <DialogContentText>
                        {"Avenida Manuel Bandeira, 360 - STATE - Vila Leopoldina - São Paulo/SP - Cep: 05317-020"}
                    </DialogContentText>

                    <Typography variant="subtitle2">
                        {"Centro de distribuição: "}
                        <b>MG (101)</b>
                    </Typography>
                    <DialogContentText>
                        {"Rua Vargem Do Joao Pinto, 450 - Galpao2 Bloco R Bairro: Da Ponte Nova - Extrema/MG - Cep: 37640000"}
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        </div>
    );
}
